<template>
  <TableLayout :permissions="['business:managers:query']">
    <!-- 搜索表单 -->
    <SearchFormCollapse slot="search-form">
      <el-form ref="searchForm" :model="searchForm" label-width="100px" inline>
        <el-form-item label="主键" prop="id">
          <el-input v-model="searchForm.id" placeholder="请输入主键" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建人编码" prop="creator">
          <el-input v-model="searchForm.creator" placeholder="请输入创建人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="createDate">
          <el-date-picker v-model="searchForm.createDate" value-format="yyyy-MM-dd" placeholder="请输入创建时间" @change="search"/>
        </el-form-item>
        <el-form-item label="更新人编码" prop="editor">
          <el-input v-model="searchForm.editor" placeholder="请输入更新人编码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="更新时间" prop="editDate">
          <el-date-picker v-model="searchForm.editDate" value-format="yyyy-MM-dd" placeholder="请输入更新时间" @change="search"/>
        </el-form-item>
        <el-form-item label="是否删除0否 1是" prop="isdeleted">
          <el-input v-model="searchForm.isdeleted" placeholder="请输入是否删除0否 1是" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="所属分类编（关联category)" prop="categoryId">
          <el-input v-model="searchForm.categoryId" placeholder="请输入所属分类编（关联category)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="searchForm.remark" placeholder="请输入备注" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="状态 0启用 1禁用" prop="status">
          <el-input v-model="searchForm.status" placeholder="请输入状态 0启用 1禁用" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="排序码" prop="sortnum">
          <el-input v-model="searchForm.sortnum" placeholder="请输入排序码" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="类型 0DCA责任人1安全风险物业主管 2安全风险处理工程师 4SHE负责人 5SHE工单邮箱抄送人" prop="type">
          <el-input v-model="searchForm.type" placeholder="请输入类型 0DCA责任人1安全风险物业主管 2安全风险处理工程师 4SHE负责人 5SHE工单邮箱抄送人" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="人员编码（关联member)" prop="memberId">
          <el-input v-model="searchForm.memberId" placeholder="请输入人员编码（关联member)" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <el-form-item label="" prop="column13">
          <el-input v-model="searchForm.column13" placeholder="请输入" @keypress.enter.native="search"></el-input>
        </el-form-item>
        <section>
          <el-button type="primary" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
    </SearchFormCollapse>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar" v-permissions="['business:managers:create', 'business:managers:delete']">
        <li><el-button type="primary" @click="$refs.operaManagersWindow.open('新建责任人信息表')" icon="el-icon-plus" v-permissions="['business:managers:create']">新建</el-button></li>
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete" v-permissions="['business:managers:delete']">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="主键" min-width="100px"></el-table-column>
        <el-table-column prop="creator" label="创建人编码" min-width="100px"></el-table-column>
        <el-table-column prop="createDate" label="创建时间" min-width="100px"></el-table-column>
        <el-table-column prop="editor" label="更新人编码" min-width="100px"></el-table-column>
        <el-table-column prop="editDate" label="更新时间" min-width="100px"></el-table-column>
        <el-table-column prop="isdeleted" label="是否删除0否 1是" min-width="100px"></el-table-column>
        <el-table-column prop="categoryId" label="所属分类编（关联category)" min-width="100px"></el-table-column>
        <el-table-column prop="remark" label="备注" min-width="100px"></el-table-column>
        <el-table-column prop="status" label="状态 0启用 1禁用" min-width="100px"></el-table-column>
        <el-table-column prop="sortnum" label="排序码" min-width="100px"></el-table-column>
        <el-table-column prop="type" label="类型 0DCA责任人1安全风险物业主管 2安全风险处理工程师 4SHE负责人 5SHE工单邮箱抄送人" min-width="100px"></el-table-column>
        <el-table-column prop="memberId" label="人员编码（关联member)" min-width="100px"></el-table-column>
        <el-table-column prop="column13" label="" min-width="100px"></el-table-column>
        <el-table-column
          v-if="containPermissions(['business:managers:update', 'business:managers:delete'])"
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" @click="$refs.operaManagersWindow.open('编辑责任人信息表', row)" icon="el-icon-edit" v-permissions="['business:managers:update']">编辑</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete" v-permissions="['business:managers:delete']">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 新建/修改 -->
    <OperaManagersWindow ref="operaManagersWindow" @success="handlePageChange"/>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import SearchFormCollapse from '@/components/common/SearchFormCollapse'
import Pagination from '@/components/common/Pagination'
import OperaManagersWindow from '@/components/business/OperaManagersWindow'
export default {
  name: 'Managers',
  extends: BaseTable,
  components: { SearchFormCollapse, TableLayout, Pagination, OperaManagersWindow },
  data () {
    return {
      // 搜索
      searchForm: {
        id: '',
        creator: '',
        createDate: '',
        editor: '',
        editDate: '',
        isdeleted: '',
        categoryId: '',
        remark: '',
        status: '',
        sortnum: '',
        type: '',
        memberId: '',
        column13: ''
      }
    }
  },
  created () {
    this.config({
      module: '责任人信息表',
      api: '/business/managers',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  }
}
</script>
